module.exports = __webpack_public_path__ + "img/elastic length.21c93067.png";